import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["partialToUpdate"];

  connect() {
    console.log("Ajax controller connected");
  }

  updateHtml(event) {
    const [_data, _status, xhr] = event.detail;
    this.partialToUpdateTarget.outerHTML = xhr.response;
  }
}
